import PhotoUploadDialog from './PhotoUploadDialogContainer';

export default PhotoUploadDialog;
